import { baseApi as api } from "../../../contexts/endpoints/base_api";
import { PhoneNumber } from "../../../contexts/endpoints/shared/types";

const injectedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPublicProfile: build.query<
      GetPublicProfileApiResponse,
      GetPublicProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/account/publicProfile/${queryArg.publicId}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export type GetPublicProfileApiResponse =
  /** status 200 OK */ PublicProfileDetails;
export type GetPublicProfileApiArg = {
  publicId: string;
};
export type PublicProfileDetails = {
  id: string;
  firstName: string;
  lastName: string;
  avatarUrl: string;
  createdAt: string;
  primaryEmailAddress?: string;
  phoneNumber?: PhoneNumber;
  jobTitle?: string;
  country?: string;
  certifications: any[];
  credentials: any[];
  electiveStudies: any[];
};

export const { useGetPublicProfileQuery } = injectedApi;
